import { createChat } from 'apis/AiChat/AiChat';
import { useMutation } from 'react-query';
import { AiChatHistory, AiChatType } from 'types';

export const useCreateNewChat = () => {
  return useMutation<AiChatHistory, any, { chatType: AiChatType; name?: string }>(createChat);
};
